<app-page-body
  [class]="'tw-pt-2'"
  *ngIf="config?.isShowPageHeader && !isVisibleHelpPage"
>
  <app-page-header
    [title]="config?.title"
    [loading]="baseLoading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    [showRefreshBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      @if (!config?.isEdit) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'sendQueue'
            : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
        iconSize="mdi-22px"
      ></page-header-btn>
      }

      <ng-container *ngIf="config?.isEdit">
        <a
          class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise"
          mat-ripple
          [matTooltip]="'common.refresh' | translate"
          (click)="onReset()"
        >
          <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
        </a>
        <a
          class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
          mat-ripple
          [matTooltip]="'common.back' | translate"
          (click)="emitClosePage()"
        >
          <i class="mdi mdi-arrow-left mdi-20px p-0"></i>
        </a>
      </ng-container>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <form [id]="formId" [formGroup]="form" autocomplete="off">
      <div class="row panels-row send-sms-row">
        <!-- part 1 messageInformation -->
        <section
          *ngIf="!config?.isCustomMessageInformation"
          class="tw-pr-2 tw-pl-0"
          [class]="
            !(config?.sendType === SendTypes.Phonebook && config?.isEdit)
              ? config?.msgInfoClassList
              : null
          "
          [ngClass]="{
            '[@media_(max-width:650px)]:tw-w-full [@media_(min-width:650px)_and_(max-width:768px)]:tw-w-[45%] [@media_(min-width:768px)_and_(max-width:1024px)]:tw-w-[40%] [@media_(min-width:1024px)_and_(max-width:1175px)]:tw-w-[35%] [@media_(min-width:1175px)_and_(max-width:1515px)]:tw-w-[35%] [@media_(min-width:1515px)]:tw-w-[25%] tw-mt-2':
              config?.sendType === SendTypes.Phonebook && config?.isEdit
          }"
        >
          <fieldset class="tw-h-full" formGroupName="messageInformation">
            <legend class="tw-flex-center">
              <i class="mdi mdi-message-cog tw-ml-2"></i>
              {{ pageVocabs + "legends.messageInformation" | translate }}
            </legend>

            <div class="row">
              <!-- senderNumberId + smsBody -->
              <app-sms-body
                [form]="form"
                groupName="messageInformation"
                smsBodyControlName="smsBody"
                senderNumberControlName="senderNumberId"
                voiceMessageControlName="voiceMessageId"
                socialMediaMessageControlName="socialMediaFileId"
                socialMediaApplicationControlName="socialMediaApplicationId"
                maxTryCountControlName="maxTryCount"
                minuteBetweenTriesControlName="minuteBetweenTries"
                [useType]="config?.useType"
                [sendType]="config?.sendType"
                [isAddSignature]="
                  !config?.isEdit ? config?.isAddSignature : false
                "
                [isAddHeader]="!config?.isEdit ? config?.isAddHeader : false"
                [privateNumberType]="config?.privateNumberType"
                [senderNumberId]="baseModel.senderNumberId"
                [smsBody]="baseModel.smsBody"
                [voiceMessageId]="baseModel.voiceMessageId"
                [minuteBetweenTries]="baseModel.minuteBetweenTries"
                [maxTryCount]="baseModel.maxTryCount"
                [socialMediaFileId]="baseModel.socialMediaFileId"
                [socialMediaFileTitle]="baseModel.socialMediaFileTitle"
                [socialMediaApplicationId]="baseModel.socialMediaApplicationId"
                [socialMediaApplicationName]="
                  baseModel.socialMediaApplicationName
                "
                [isEditMode]="config?.isEdit"
                (smsBody)="baseModel.smsBody = $event; emitModel()"
                (finalSmsBody)="baseModel.finalSmsBody = $event; emitModel()"
                (senderNumberId)="
                  baseModel.senderNumberId = $event; emitModel()
                "
                (senderNumber)="
                  baseModel.isCanSendVoice = $event?.isCanSendVoice;
                  changeValidations($event);
                  baseModel.isCanSendFlashSms = $event?.isCanSendFlashSms
                "
                (senderNumber)="
                  baseModel.isCanSendSocialMedia = $event?.smsCp == SmsCp.Mxb;
                  baseModel.isTwilioNumber = $event?.smsCp == SmsCp.Twilio;
                  changeValidations($event)
                "
                (smsCount)="baseModel.smsCount = $event; emitModel()"
                (voiceMessageDetails)="
                  baseModel.voiceMessageDetails = $event; emitModel()
                "
                (socialMediaMessageDetails)="
                  baseModel.socialMediaMessageDetails = $event; emitModel()
                "
              >
                <!-- campaign -->
                <div after-private-number>
                  <list-group-item
                    *ngIf="config?.isShowCampaign && baseModel?.title"
                    [label]="'common.campaign'"
                    [showValueInMaxOneRow]="true"
                    [value]="baseModel?.title"
                  >
                    <i
                      icon
                      class="mdi mdi-message-badge-outline tw-text-gray-700 tw-ml-2 mdi-20px"
                    ></i>
                  </list-group-item>
                </div>
              </app-sms-body>

              <!-- extraReceivers -->
              <div
                class="tw-flex-center flex-column tw-mt-5 rtl:tw-ml-[-59px] ltr:tw-mr-[-59px]"
                *ngIf="
                  config?.isShowExtraReceivers &&
                  currentUserInfo.isCanSendExtraReceivers
                "
              >
                <div class="tw-w-full tw-mr-1 tw-mb-2">
                  <span class="text-danger">*</span>
                  <span
                    class="tw-text-gray-700 dark:tw-text-gray-300"
                    translate
                    [translateParams]="{ number: 5 }"
                  >
                    messages.maxReceiversMsg
                  </span>
                </div>

                <div class="tw-w-full">
                  <app-chip-list
                    [maxLength]="5"
                    [title]="'common.extraReceivers' | translate"
                    [placeholder]="
                      'messages.separateByCommaAndEnter' | translate
                    "
                    [checkInputWhenBlur]="true"
                    (items)="getExtraReceivers($event)"
                  >
                  </app-chip-list>
                </div>
              </div>

              <!-- fast send -->
              <div
                class="tw-w-full tw-mr-1 tw-mb-2"
                *ngIf="config?.isShowFastSend"
              >
                <span class="text-danger">*</span>
                <span
                  class="tw-text-gray-700 dark:tw-text-gray-300"
                  translate
                  [translateParams]="{ number: 5 }"
                >
                  messages.maxReceiversMsg
                </span>
              </div>
              <div
                class="tw-flex align-items-start tw-mt-3"
                *ngIf="config?.isShowFastSend"
              >
                <div class="tw-w-full">
                  <app-chip-list
                    [maxLength]="5"
                    [title]="fields + 'receivers'"
                    [placeholder]="
                      'messages.separateByCommaAndEnter' | translate
                    "
                    [checkInputWhenBlur]="true"
                    (items)="baseModel.fastSendReceivers = $event; emitModel()"
                  >
                  </app-chip-list>
                </div>

                <!-- fast send button -->
                <!-- [disabled]="!baseModel?.senderNumberId || !baseModel?.smsBody || !baseModel.fastSendReceivers" -->
                <button
                  [disabled]="
                    !baseModel?.senderNumberId ||
                    !baseModel.fastSendReceivers ||
                    (!baseModel.isCanSendSocialMedia && !baseModel.finalSmsBody)
                  "
                  class="btn fast-send-btn tw-mt-1 btn-hover-rise"
                  [themeColor]="'btn-info'"
                  (click)="emitFastSend()"
                >
                  <span *ngIf="!fastSendLoading">
                    {{ pageVocabs + "fastSend" | translate }}
                  </span>
                  <span *ngIf="fastSendLoading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Loading...</span>
                  </span>
                </button>
              </div>

              <ng-content select="[section-one-more-content]"></ng-content>
            </div>
          </fieldset>
        </section>

        <!-- part 1 custom messageInformation -->
        <section
          *ngIf="config?.isCustomMessageInformation"
          class="tw-pr-2 tw-pl-0"
          [class]="config?.msgInfoClassList"
        >
          <ng-content select="[messageInformation]"></ng-content>
        </section>

        <!-- part 2 receivers -->
        <section
          *ngIf="config?.isShowReceivers"
          class="tw-pr-2 tw-pl-0"
          [class]="config?.receiversClassList"
        >
          <ng-content select="[receivers]"></ng-content>
        </section>

        <section
          *ngIf="config?.isEdit && isShowPhonebook"
          class="tw-pr-2 tw-pl-0"
          [class]="
            !(config?.sendType === SendTypes.Phonebook && config?.isEdit)
              ? config?.sendDateTimeClassList
              : null
          "
          [ngClass]="{
            '[@media_(max-width:650px)]:tw-w-full [@media_(min-width:650px)_and_(max-width:768px)]:tw-w-[55%] [@media_(min-width:768px)_and_(max-width:1024px)]:tw-w-[60%] [@media_(min-width:1024px)_and_(max-width:1175px)]:tw-w-[65%] [@media_(min-width:1175px)_and_(max-width:1515px)]:tw-w-[65%] [@media_(min-width:1515px)]:tw-w-[50%] tw-mt-2':
              config?.sendType === SendTypes.Phonebook && config?.isEdit
          }"
        >
          <fieldset
            class="tw-h-full tw-grid"
            formGroupName="sendTypeInformation"
          >
            <legend class="tw-flex-center">
              <i class="mdi mdi-card-account-phone tw-ml-2"></i>
              {{ "common.phonebook" | translate }}
            </legend>

            <div>
              <phonebook-selector
                [isShowInputs]="true"
                [isShowGlobalIndex]="false"
                (recipientsChange)="changeRecipients($event)"
              >
              </phonebook-selector>
            </div>
          </fieldset>
        </section>

        <!-- part 3 sendTypeInformation-->
        <section
          class="tw-pr-2 tw-pl-1"
          [class]="
            !(config?.sendType === SendTypes.Phonebook && config?.isEdit)
              ? config?.sendDateTimeClassList
              : null
          "
          [ngClass]="{
            '[@media_(max-width:650px)]:tw-w-full [@media_(min-width:650px)_and_(max-width:768px)]:tw-w-[45%] [@media_(min-width:768px)_and_(max-width:1024px)]:tw-w-[40%] [@media_(min-width:1024px)_and_(max-width:1175px)]:tw-w-[35%] [@media_(min-width:1175px)_and_(max-width:1515px)]:tw-w-[35%] [@media_(min-width:1515px)]:tw-w-[25%] tw-mt-2':
              config?.sendType === SendTypes.Phonebook && config?.isEdit
          }"
        >
          <fieldset class="tw-h-full" formGroupName="sendTypeInformation">
            <legend class="tw-flex-center">
              <i class="mdi mdi-calendar-clock tw-ml-2"></i>
              {{ pageVocabs + "legends.sendDateTimeType" | translate }}
            </legend>

            <div class="row tw-flex flex-column tw-justify-between tw-h-full">
              <div class="tw-px-1">
                <mat-accordion (click)="onLogForm()">
                  <!-- (1) sendDateTimeChecked -->
                  <mat-expansion-panel
                    (opened)="onChangeSendType(SendDateTimeType.DateTime)"
                    [expanded]="isExpandDirectDateTime"
                    *ngIf="isShowDirectSend"
                    style="
                      border-radius: 5px !important;
                      margin-top: 10px !important;
                    "
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div>
                          <mat-radio-group
                            formControlName="sendDateTimeChecked"
                            [(ngModel)]="baseModel.sendDateTimeType"
                          >
                            <mat-radio-button
                              [value]="SendDateTimeType.DateTime"
                              [checked]="
                                baseModel.sendDateTimeType ==
                                SendDateTimeType.DateTime
                              "
                            >
                            </mat-radio-button>
                            {{ fields + "sendDirect" | translate }}
                          </mat-radio-group>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- date time picker -->
                    <app-date-time-picker
                      [config]="directDateTimeConfig"
                      (dateTime)="
                        baseModel.directSendDateTime = $event; emitModel()
                      "
                    >
                    </app-date-time-picker>
                  </mat-expansion-panel>

                  <!-- (2) sendPeriodChecked -->
                  <mat-expansion-panel
                    (opened)="onChangeSendType(SendDateTimeType.Period)"
                    [expanded]="isExpandPeriodDateTime"
                    *ngIf="isShowPeriodicSend && !baseModel.isCanSendVoice"
                    style="
                      border-radius: 5px !important;
                      margin-top: 10px !important;
                    "
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div>
                          <mat-radio-group
                            formControlName="sendPeriodChecked"
                            [(ngModel)]="baseModel.sendDateTimeType"
                          >
                            <mat-radio-button
                              [value]="SendDateTimeType.Period"
                              [checked]="
                                baseModel.sendDateTimeType ==
                                SendDateTimeType.Period
                              "
                            >
                            </mat-radio-button>
                            {{ fields + "sendPeriod" | translate }}
                          </mat-radio-group>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="row">
                      <!-- periodic type & periodic text -->
                      <app-periodic-type
                        [config]="periodicTypeConfig"
                        (periodType)="
                          baseModel.periodTypeValue = $event; emitModel()
                        "
                        (periodText)="
                          baseModel.gradualPeriodText = $event; emitModel()
                        "
                      >
                      </app-periodic-type>

                      <!-- periodic date time picker -->
                      <app-periodic-date-time-picker
                        [config]="periodicDateTimeConfig"
                        (startDateTime)="
                          baseModel.periodicSendStartDateTime = $event;
                          emitModel()
                        "
                        (endDateTime)="
                          baseModel.periodicSendEndDateTime = $event;
                          emitModel()
                        "
                      >
                      </app-periodic-date-time-picker>
                    </div>
                  </mat-expansion-panel>

                  <!-- (3)gradualChecked -->
                  <mat-expansion-panel
                    (opened)="onChangeSendType(SendDateTimeType.Gradual)"
                    [expanded]="isExpandGradualDateTime"
                    *ngIf="isShowGradualSend && !baseModel.isCanSendVoice"
                    style="
                      border-radius: 5px !important;
                      margin-top: 10px !important;
                    "
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div>
                          <mat-radio-group
                            formControlName="gradualChecked"
                            [(ngModel)]="baseModel.sendDateTimeType"
                          >
                            <mat-radio-button
                              [value]="SendDateTimeType.Gradual"
                              [checked]="
                                baseModel.sendDateTimeType ==
                                SendDateTimeType.Gradual
                              "
                            >
                            </mat-radio-button>
                            {{ fields + "sendGradual" | translate }}
                          </mat-radio-group>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="row">
                      <!-- alert -->
                      <div class="tw-w-full tw-px-0" *ngIf="!config?.isEdit">
                        <div class="alert alert-blue">
                          {{ pageVocabs + "gradualAlert" | translate }}
                        </div>
                      </div>

                      <!--gradual date time picker -->
                      <app-date-time-picker
                        [config]="gradualDateTimeConfig"
                        (dateTime)="
                          baseModel.gradualSendDateTime = $event; emitModel()
                        "
                      >
                      </app-date-time-picker>

                      <!-- gradualPeriodText -->
                      <div class="xl:tw-w-1/2 tw-w-full tw-px-1">
                        <form-field
                          type="tel"
                          [hasNumberSeparator]="true"
                          [value]="baseModel.gradualPeriodText"
                          (valueChange)="
                            baseModel.gradualPeriodText = $event; emitModel()
                          "
                          [control]="
                            form?.get('sendTypeInformation.gradualPeriodText')
                          "
                          [label]="fields + 'everyFewMinutes'"
                          [min]="
                            isShowGradualSend &&
                            baseModel.sendDateTimeType ==
                              SendDateTimeType.Gradual
                              ? 1
                              : null
                          "
                        >
                        </form-field>
                      </div>

                      <!-- gradualPageSize -->
                      <div class="xl:tw-w-1/2 tw-w-full tw-px-1">
                        <form-field
                          type="tel"
                          [hasNumberSeparator]="true"
                          [value]="baseModel.gradualPageSize"
                          (valueChange)="
                            baseModel.gradualPageSize = $event; emitModel()
                          "
                          [control]="
                            form?.get('sendTypeInformation.gradualPageSize')
                          "
                          [label]="fields + 'numberOfSubmissions'"
                          [step]="1000"
                          [min]="
                            isShowGradualSend &&
                            baseModel.sendDateTimeType ==
                              SendDateTimeType.Gradual
                              ? 1000
                              : null
                          "
                        >
                        </form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>

                <!-- description -->
                <div class="tw-w-full tw-mt-5">
                  <form-textarea
                    class="tw-w-full"
                    label="common.description"
                    [(value)]="baseModel.description"
                    [control]="form?.get('description')"
                    [rows]="1"
                    (valueChange)="emitModel()"
                  >
                  </form-textarea>
                </div>

                <!-- isSendWhiteList -->
                <div
                  class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                  *ngIf="!config?.isEdit"
                >
                  <mat-slide-toggle
                    [(ngModel)]="baseModel.isSendWhiteList"
                    (change)="emitModel()"
                    formControlName="isSendWhiteList"
                  >
                    {{ pageVocabs + "justSendToWhiteList" | translate }}
                  </mat-slide-toggle>
                </div>

                <!-- isFlashSms -->
                <div
                  class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                  *ngIf="baseModel.isCanSendFlashSms"
                >
                  <mat-slide-toggle
                    [(ngModel)]="baseModel.isFlashSms"
                    (change)="emitModel()"
                    formControlName="isFlashSms"
                  >
                    {{ pageVocabs + "isFlashSms" | translate }}
                  </mat-slide-toggle>
                </div>

                <!-- saveToCampaign -->
                <div
                  class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-2"
                  *ngIf="!config?.isEdit && config?.isShowCampaign"
                >
                  <mat-slide-toggle
                    [(ngModel)]="saveToCampaign"
                    (change)="onChangeSaveToCampaign()"
                    formControlName="isSendWhiteList"
                  >
                    {{ "common.saveToCampaign" | translate }}
                  </mat-slide-toggle>
                  <!-- [disabled]="form.invalid" -->
                </div>
              </div>

              <div class="tw-flex flex-column tw-mt-2">
                <!-- submit btn -->
                <button
                  type="button"
                  mat-ripple
                  class="btn tw-py-2 tw-mb-1 tw-w-full button-shadow btn-hover-rise"
                  [themeColor]="'btn-gradient'"
                  [disabled]="baseLoading || isWrongIndex"
                  (click)="onSubmit()"
                >
                  <ng-container *ngIf="!baseLoading">
                    <!-- create mode -->
                    <ng-container *ngIf="!config?.isEdit">
                      {{ pageVocabs + "sendSms" | translate }}
                      <i class="fas fa-paper-plane tw-text-2xl"></i>
                    </ng-container>

                    <!-- edit mode -->
                    <ng-container *ngIf="config?.isEdit">
                      {{ pageVocabs + "editSendSms" | translate }}
                      <i class="fas fa-pen tw-text-2xl"></i>
                    </ng-container>
                  </ng-container>

                  <!-- loading -->
                  <ng-container *ngIf="baseLoading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </ng-container>
                </button>
              </div>
            </div>
          </fieldset>
        </section>

        <ng-content select="[more]"></ng-content>
      </div>
    </form>

    <ng-content select="[special-loading]"></ng-content>
  </div>
</app-page-body>

<!-- content -->
<div class="app-page-content" *ngIf="!config?.isShowPageHeader">
  <form [id]="formId" [formGroup]="form" autocomplete="off">
    <div class="row panels-row send-sms-row">
      <!-- part 1 messageInformation -->
      <section class="tw-px-0 tw-h-auto" [class]="config?.msgInfoClassList">
        <fieldset class="tw-h-full" formGroupName="messageInformation">
          <legend class="tw-flex-center">
            <i class="mdi mdi-message-cog tw-ml-2"></i>
            {{ pageVocabs + "legends.messageInformation" | translate }}
          </legend>

          <div class="row">
            <app-sms-body
              [form]="form"
              groupName="messageInformation"
              smsBodyControlName="smsBody"
              senderNumberControlName="senderNumberId"
              voiceMessageControlName="voiceMessageId"
              socialMediaMessageControlName="socialMediaFileId"
              socialMediaApplicationControlName="socialMediaApplicationId"
              socialMediaApplication="socialMediaApplicationId"
              maxTryCountControlName="maxTryCount"
              minuteBetweenTriesControlName="minuteBetweenTries"
              [useType]="config?.useType"
              [sendType]="config?.sendType"
              [isAddSignature]="config?.isAddSignature"
              [isAddHeader]="config?.isAddHeader"
              [privateNumberType]="config?.privateNumberType"
              [senderNumberId]="baseModel.senderNumberId"
              [smsBody]="baseModel.smsBody"
              [voiceMessageId]="baseModel.voiceMessageId"
              [minuteBetweenTries]="baseModel.minuteBetweenTries"
              [maxTryCount]="baseModel.maxTryCount"
              [socialMediaFileId]="baseModel.socialMediaFileId"
              [socialMediaFileTitle]="baseModel.socialMediaFileTitle"
              [socialMediaApplicationId]="baseModel.socialMediaApplicationId"
              [socialMediaApplicationName]="
                baseModel.socialMediaApplicationName
              "
              [isEditMode]="config?.isEdit"
              (smsBody)="baseModel.smsBody = $event; emitModel()"
              (finalSmsBody)="baseModel.finalSmsBody = $event; emitModel()"
              (senderNumberId)="baseModel.senderNumberId = $event; emitModel()"
              (senderNumber)="
                baseModel.isCanSendVoice = $event?.isCanSendVoice;
                changeValidations($event);
                baseModel.isCanSendFlashSms = $event?.isCanSendFlashSms
              "
              (senderNumber)="
                baseModel.isCanSendSocialMedia = $event?.smsCp == SmsCp.Mxb;
                baseModel.isTwilioNumber = $event?.smsCp == SmsCp.Twilio;
                changeValidations($event)
              "
              (smsCount)="baseModel.smsCount = $event; emitModel()"
              (voiceMessageDetails)="
                baseModel.voiceMessageDetails = $event; emitModel()
              "
              (socialMediaMessageDetails)="
                baseModel.socialMediaMessageDetails = $event; emitModel()
              "
            >
            </app-sms-body>

            <!-- extraReceivers -->
            <div
              class="tw-flex-center flex-column tw-mt-5"
              *ngIf="
                config?.isShowExtraReceivers &&
                currentUserInfo.isCanSendExtraReceivers
              "
            >
              <div class="tw-w-full tw-mr-1 tw-mb-2">
                <span class="text-danger">*</span>
                <span
                  class="tw-text-gray-700 dark:tw-text-gray-300"
                  translate
                  [translateParams]="{ number: 5 }"
                >
                  messages.maxReceiversMsg
                </span>
              </div>

              <div class="tw-w-full">
                <app-chip-list
                  [maxLength]="5"
                  [title]="'common.extraReceivers' | translate"
                  [placeholder]="'messages.separateByCommaAndEnter' | translate"
                  [checkInputWhenBlur]="true"
                  (items)="getExtraReceivers($event)"
                >
                </app-chip-list>
              </div>
            </div>

            <!-- fast send -->
            <div
              class="tw-w-full tw-mr-1 tw-mb-2"
              *ngIf="config?.isShowFastSend"
            >
              <span class="text-danger">*</span>
              <span
                class="tw-text-gray-700 dark:tw-text-gray-300"
                translate
                [translateParams]="{ number: 5 }"
              >
                messages.maxReceiversMsg
              </span>
            </div>
            <div
              class="tw-flex align-items-start tw-mt-3"
              *ngIf="config?.isShowFastSend"
            >
              <div class="tw-w-full">
                <app-chip-list
                  [maxLength]="5"
                  [title]="fields + 'receivers'"
                  placeholder="messages.chipListPlaceholder"
                  [checkInputWhenBlur]="true"
                  (items)="baseModel.fastSendReceivers = $event; emitModel()"
                >
                </app-chip-list>
              </div>

              <!-- fast send button -->
              <button
                [disabled]="
                  !baseModel?.senderNumberId ||
                  !baseModel.fastSendReceivers ||
                  (!baseModel.isCanSendSocialMedia && !baseModel.finalSmsBody)
                "
                class="btn fast-send-btn tw-mt-1 btn-hover-rise"
                [themeColor]="'btn-info'"
                (click)="emitFastSend()"
              >
                <span *ngIf="!fastSendLoading">
                  {{ pageVocabs + "fastSend" | translate }}
                </span>
                <span *ngIf="fastSendLoading">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">Loading...</span>
                </span>
              </button>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- part 2 receivers -->
      <section
        *ngIf="config?.isShowReceivers"
        class="tw-px-1 tw-h-auto"
        [class]="config?.receiversClassList"
      >
        <ng-content select="[receivers]"></ng-content>
      </section>

      <!-- part 3 sendTypeInformation-->
      <section
        class="tw-px-0 tw-h-auto"
        [class]="config?.sendDateTimeClassList"
      >
        <fieldset class="tw-h-full" formGroupName="sendTypeInformation">
          <legend class="tw-flex-center">
            <i class="mdi mdi-calendar-clock tw-ml-2"></i>
            {{ pageVocabs + "legends.sendDateTimeType" | translate }}
          </legend>

          <div
            class="row tw-flex flex-column tw-justify-between tw-h-full tw-items-center"
          >
            <div class="tw-px-1 send-sms-body">
              <mat-accordion (click)="onLogForm()">
                <!-- (1) sendDateTimeChecked -->
                <mat-expansion-panel
                  (opened)="onChangeSendType(SendDateTimeType.DateTime)"
                  [expanded]="isExpandDirectDateTime"
                  style="
                    border-radius: 5px !important;
                    margin-top: 10px !important;
                  "
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div>
                        <mat-radio-group
                          formControlName="sendDateTimeChecked"
                          [(ngModel)]="baseModel.sendDateTimeType"
                        >
                          <mat-radio-button
                            [value]="SendDateTimeType.DateTime"
                            [checked]="
                              baseModel.sendDateTimeType ==
                              SendDateTimeType.DateTime
                            "
                          >
                          </mat-radio-button>
                          {{ fields + "sendDirect" | translate }}
                        </mat-radio-group>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <!-- date time picker -->
                  <app-date-time-picker
                    [config]="directDateTimeConfig"
                    (dateTime)="
                      baseModel.directSendDateTime = $event; emitModel()
                    "
                  >
                  </app-date-time-picker>
                </mat-expansion-panel>

                <!-- (2) sendPeriodChecked -->
                <mat-expansion-panel
                  (opened)="onChangeSendType(SendDateTimeType.Period)"
                  [expanded]="isExpandPeriodDateTime"
                  *ngIf="isShowPeriodicSend && !baseModel.isCanSendVoice"
                  style="
                    border-radius: 5px !important;
                    margin-top: 10px !important;
                  "
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div>
                        <mat-radio-group
                          formControlName="sendPeriodChecked"
                          [(ngModel)]="baseModel.sendDateTimeType"
                        >
                          <mat-radio-button
                            [value]="SendDateTimeType.Period"
                            [checked]="
                              baseModel.sendDateTimeType ==
                              SendDateTimeType.Period
                            "
                          >
                          </mat-radio-button>
                          {{ fields + "sendPeriod" | translate }}
                        </mat-radio-group>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="row">
                    <!-- periodic type & periodic text -->
                    <app-periodic-type
                      [config]="periodicTypeConfig"
                      (periodType)="
                        baseModel.periodTypeValue = $event; emitModel()
                      "
                      (periodText)="
                        baseModel.gradualPeriodText = $event; emitModel()
                      "
                    >
                    </app-periodic-type>

                    <!-- periodic date time picker -->
                    <app-periodic-date-time-picker
                      [config]="periodicDateTimeConfig"
                      (startDateTime)="
                        baseModel.periodicSendStartDateTime = $event;
                        emitModel()
                      "
                      (endDateTime)="
                        baseModel.periodicSendEndDateTime = $event; emitModel()
                      "
                    >
                    </app-periodic-date-time-picker>
                  </div>
                </mat-expansion-panel>

                <!-- (3)gradualChecked -->
                <mat-expansion-panel
                  (opened)="onChangeSendType(SendDateTimeType.Gradual)"
                  [expanded]="isExpandGradualDateTime"
                  *ngIf="isShowGradualSend && !baseModel.isCanSendVoice"
                  style="
                    border-radius: 5px !important;
                    margin-top: 10px !important;
                  "
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-radio-group
                        formControlName="gradualChecked"
                        [(ngModel)]="baseModel.sendDateTimeType"
                      >
                        <mat-radio-button
                          [value]="SendDateTimeType.Gradual"
                          [checked]="
                            baseModel.sendDateTimeType ==
                            SendDateTimeType.Gradual
                          "
                        >
                        </mat-radio-button>
                        {{ fields + "sendGradual" | translate }}
                      </mat-radio-group>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="row">
                    <!-- alert -->
                    <div class="md:tw-w-full tw-px-0" *ngIf="!config?.isEdit">
                      <div class="alert alert-blue">
                        {{ pageVocabs + "gradualAlert" | translate }}
                      </div>
                    </div>

                    <!--gradual date time picker -->
                    <app-date-time-picker
                      [config]="gradualDateTimeConfig"
                      (dateTime)="
                        baseModel.gradualSendDateTime = $event; emitModel()
                      "
                    >
                    </app-date-time-picker>

                    <!-- gradualPeriodText -->
                    <div class="xl:tw-w-1/2 tw-w-full tw-px-1">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [value]="baseModel.gradualPeriodText"
                        (valueChange)="
                          baseModel.gradualPeriodText = $event; emitModel()
                        "
                        [control]="
                          form?.get('sendTypeInformation.gradualPeriodText')
                        "
                        [label]="fields + 'everyFewMinutes'"
                        [min]="
                          isShowGradualSend &&
                          baseModel.sendDateTimeType == SendDateTimeType.Gradual
                            ? 1
                            : null
                        "
                      >
                      </form-field>
                    </div>

                    <!-- gradualPageSize -->
                    <div class="xl:tw-w-1/2 tw-w-full tw-px-1">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [value]="baseModel.gradualPageSize"
                        (valueChange)="
                          baseModel.gradualPageSize = $event; emitModel()
                        "
                        [control]="
                          form?.get('sendTypeInformation.gradualPageSize')
                        "
                        [label]="fields + 'numberOfSubmissions'"
                        [step]="1000"
                        [min]="
                          isShowGradualSend &&
                          baseModel.sendDateTimeType == SendDateTimeType.Gradual
                            ? 1000
                            : null
                        "
                      >
                      </form-field>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>

              <!-- description -->
              <form-textarea
                class="tw-w-full"
                label="common.description"
                [(value)]="baseModel.description"
                [control]="form?.get('description')"
                [rows]="1"
                (valueChange)="emitModel()"
              >
              </form-textarea>
              <!-- isSendWhiteList -->
              <div
                class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                *ngIf="!config?.isEdit"
              >
                <mat-slide-toggle
                  [(ngModel)]="baseModel.isSendWhiteList"
                  (change)="emitModel()"
                  formControlName="isSendWhiteList"
                >
                  {{ pageVocabs + "justSendToWhiteList" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isFlashSms -->
              <div
                class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                *ngIf="!config?.isEdit"
              >
                <mat-slide-toggle
                  [(ngModel)]="baseModel.isFlashSms"
                  (change)="emitModel()"
                  formControlName="isFlashSms"
                >
                  {{ pageVocabs + "isFlashSms" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- saveToCampaign -->
              <div
                class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px]"
                *ngIf="!config?.isEdit"
              >
                <mat-slide-toggle
                  [(ngModel)]="saveToCampaign"
                  (change)="onChangeSaveToCampaign()"
                  formControlName="isSendWhiteList"
                >
                  {{ "common.saveToCampaign" | translate }}
                </mat-slide-toggle>
                <!-- [disabled]="form.invalid" -->
              </div>
            </div>

            <div class="tw-flex flex-column tw-mt-2">
              <!-- submit btn -->
              <button
                type="button"
                mat-ripple
                class="btn tw-py-2 tw-mb-1 tw-w-full button-shadow btn-hover-rise"
                [themeColor]="'btn-gradient'"
                [disabled]="baseLoading"
                (click)="onSubmit()"
              >
                <ng-container *ngIf="!baseLoading">
                  <!-- create mode -->
                  <ng-container *ngIf="!config?.isEdit">
                    {{ pageVocabs + "sendSms" | translate }}
                    <i class="fas fa-paper-plane tw-text-2xl"></i>
                  </ng-container>

                  <!-- edit mode -->
                  <ng-container *ngIf="config?.isEdit">
                    {{ pageVocabs + "editSendSms" | translate }}
                    <i class="fas fa-pen tw-text-2xl"></i>
                  </ng-container>
                </ng-container>

                <!-- loading -->
                <ng-container *ngIf="baseLoading">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </ng-container>
              </button>
            </div>
          </div>
        </fieldset>
      </section>

      <ng-content select="[more]"></ng-content>
    </div>
  </form>

  <ng-content select="[special-loading]"></ng-content>
</div>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    [menuTitle]="
      config.sendType == SendTypes.Single
        ? 'SendSms'
        : config.sendType == SendTypes.Phonebook
        ? 'SendSMSWithPhonebook'
        : config.sendType == SendTypes.Bulk
        ? 'SendBalkSMS'
        : 'SendSMSFromMap'
    "
    (hidePage)="onHideHelpPage()"
    [title]="config.title"
  >
  </app-help-page>
</ng-container>
